import { render, staticRenderFns } from "./batchPutUpPop.vue?vue&type=template&id=e773aef8&scoped=true&"
import script from "./batchPutUpPop.vue?vue&type=script&lang=js&"
export * from "./batchPutUpPop.vue?vue&type=script&lang=js&"
import style0 from "./batchPutUpPop.vue?vue&type=style&index=0&id=e773aef8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e773aef8",
  null
  
)

export default component.exports